//components
import Button from "components/Button";
import CTA from "./components/CTA";
import Faqs from "./components/Faqs";
import Hero from "./components/Hero";
import PrimaryFeatures from "./components/PrimaryFeatures";
import Container from "components/Container";
import {
  ChatBubbleLeftIcon,
  ClipboardDocumentListIcon,
  SpeakerWaveIcon,
  UserPlusIcon,
} from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

export default function Home() {
  return (
    <main>
      <Hero />
      <PrimaryFeatures />
      <div className="grid grid-cols-1 gap-y-4 lg:grid-cols-3 my-12">
        <div className="col-span-2 px-8 max-w-[600px] flex items-center justify-center mx-auto">
          <div className="flex flex-col gap-4">
            <div class="text-[#181d27] text-xl lg:text-5xl font-bold font-['Space Grotesk'] lg:leading-[60px]">
              Join our fast growing procurement network in Asia
            </div>
            <ul className="flex flex-col gap-2">
              <li className="flex gap-2">
                <svg
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.24998 14L12.75 17.5L19.75 10.5M26.1666 14C26.1666 20.4433 20.9433 25.6667 14.5 25.6667C8.05666 25.6667 2.83331 20.4433 2.83331 14C2.83331 7.55669 8.05666 2.33334 14.5 2.33334C20.9433 2.33334 26.1666 7.55669 26.1666 14Z"
                    stroke="#155EEF"
                    stroke-width="2.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p>90-day free trial</p>
              </li>
              <li className="flex gap-2">
                <svg
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.24998 14L12.75 17.5L19.75 10.5M26.1666 14C26.1666 20.4433 20.9433 25.6667 14.5 25.6667C8.05666 25.6667 2.83331 20.4433 2.83331 14C2.83331 7.55669 8.05666 2.33334 14.5 2.33334C20.9433 2.33334 26.1666 7.55669 26.1666 14Z"
                    stroke="#155EEF"
                    stroke-width="2.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p>Access both Tenders and Quotations</p>
              </li>
              <li className="flex gap-2">
                <svg
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.24998 14L12.75 17.5L19.75 10.5M26.1666 14C26.1666 20.4433 20.9433 25.6667 14.5 25.6667C8.05666 25.6667 2.83331 20.4433 2.83331 14C2.83331 7.55669 8.05666 2.33334 14.5 2.33334C20.9433 2.33334 26.1666 7.55669 26.1666 14Z"
                    stroke="#155EEF"
                    stroke-width="2.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p>Access to all features</p>
              </li>
            </ul>
            <div className="flex gap-2">
              <Button variant={"outline"}>Learn More</Button>
              <Button>Get Started</Button>
            </div>
          </div>
        </div>
        <div>
          <img src="/join-us.jpg" alt="" className="max-w-full" />
        </div>
      </div>
      <div className="pb-12">
        <div className="max-w-[600px] px-4 mx-auto text-center flex flex-col gap-2">
          <span className="text-blue-500 font-bold">Features</span>
          <h1 className="text-3xl font-bold text-black">
            360 (Supplier and Buyer) Network
          </h1>
          <p>
            Powerful, self-serve product and growth analytics to help you
            convert, engage, and retain more users. Trusted by over 4,000
            startups.
          </p>
        </div>
        <Container className="mt-8">
          <div className="grid grid-cols-1 lg:grid-cols-8">
            <div className="col-span-2">
              <div className="flex flex-col gap-2 mb-12">
                <span className="border flex items-center justify-center rounded-lg size-10 shadow mb-4">
                  <SpeakerWaveIcon className="size-6" />
                </span>
                <h2 className="text-black text-xl font-bold leading-6">
                  Buyer list Tenders & Quotations
                </h2>
                <p>
                  Whether you have a team of 2 or 200, our shared team inboxes
                  keep everyone on the same page and in the loop.
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <span className="border flex items-center justify-center rounded-lg size-10 shadow mb-4">
                  <UserPlusIcon className="size-6" />
                </span>
                <h2 className="text-black text-xl font-bold leading-6">
                  Buyer choose the best
                </h2>
                <p>
                  An all-in-one customer service platform that helps you balance
                  everything your customers need to be happy.
                </p>
              </div>
            </div>
            <div className="col-span-4">
              <img src="/network.png" alt="" className="max-w-full" />
            </div>
            <div className="col-span-2">
              <div className="flex flex-col gap-2 mb-12">
                <span className="border flex items-center justify-center rounded-lg size-10 shadow mb-4">
                  <ClipboardDocumentListIcon className="size-6" />
                </span>
                <h2 className="text-black text-xl font-bold leading-6">
                  Supplier browse from 1000s of opportunities
                </h2>
                <p>
                  Measure what matters with Untitled’s easy-to-use reports. You
                  can filter, export, and drilldown on the data in a couple
                  clicks.
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <span className="border flex items-center justify-center rounded-lg size-10 shadow mb-4">
                  <ChatBubbleLeftIcon className="size-6" />
                </span>
                <h2 className="text-black text-xl font-bold leading-6">
                  Supplier submit their best bid
                </h2>
                <p>
                  Solve a problem or close a sale in real-time with chat. If no
                  one is available, customers are seamlessly routed to email
                  without confusion.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Container>
        <div className="grid grid-cols-1 gap-y-4 lg:grid-cols-2 py-12 border-t">
          <div className="pr-8">
            <span className="text-blue-500 mb-4 block">Join us</span>
            <h1 className="font-bold text-black text-4xl leading-10 mb-4">
              Simple, transparent pricing
            </h1>
            <p>
              Simple, transparent pricing that grows with you. Try any plan free
              for 30 days.
            </p>
          </div>
          <div className="grid gap-4 grid-cols-2">
            <div className="shadow-lg rounded-xl p-4">
              <div className="text-center">
                <span className="font-bold text-4xl text-black">$99</span>
                <p className="text-black">Monthly</p>
              </div>
              <ul className="flex gap-2 flex-col mt-4">
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Browse all tenders and quotations</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>20 Request to participate</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>15 tenders / RFQs can submit</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Your business profile</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Basic chat and email support</p>
                </li>
              </ul>
              <Button className={"mt-4 w-full"} href="supplier-register">
                Get Started
              </Button>
            </div>
            <div className="shadow-lg rounded-xl p-4">
              <div className="text-center">
                <span className="font-bold text-4xl text-black">$999</span>
                <p className="text-black">Yearly</p>
              </div>
              <ul className="flex gap-2 flex-col mt-4">
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Release 10 tenders / quotations per month</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Browse the supplier list</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Up to 20 individual users</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Escrow service</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Basic chat and email support</p>
                </li>
              </ul>
              <Button className={"mt-4 w-full"} href="supplier-register">
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </main>
  );
}
